import { isNull as _isNull } from 'lodash';

export default (inletValue?: any): boolean => {
    return _isNull(inletValue);
};
